import { rollPositionCodes } from "@/shared/selectors/RollPositionSelector";
import { Tooltip } from "@mui/material";

type StatusTagProps = {
	position: { Code: string; Name: string };
};
export const RollPositionTag = ({ position }: StatusTagProps) => {
	if (!position || !position.Code || !position.Name) {
		return null;
	}
	const backgroundColor = rollPositionCodes.find(
		(p) => p.Code === position.Code,
	)?.Color;

	return (
		<Tooltip title={position.Name} arrow>
			<div
				style={{
					width: "26px",
					height: "26px",
					borderRadius: 4,
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					color: "#fff",
					fontWeight: "bold",
					backgroundColor,
				}}
			>
				{position.Code.charAt(0).toUpperCase()}
			</div>
		</Tooltip>
	);
};
